import { createContext } from 'react';
import { log } from '@utils';

export default createContext({
  product: {},
  initiated: false,
  listView: true,
  stores: [],
  allStores: [],
  filteredStores: [],
  activeStore: {},
  tempStoreId: null,
  selectMode: false,
  googleLoaded: false,
  searching: false,
  stockOnly: false,
  onSelect: () => {},
  reloadMap: () => {},
  searchMethod: () => {},
  toggleOpenMethod: () => {},
  toggleListView: () => log('ctx: toggleListView not set'),
  setStores: () => log('ctx: setStores not set'),
  setFilteredStores: () => log('ctx: setFilteredStores not set'),
  setActiveStore: () => log('ctx: setActiveStore not set'),
  setReloadMapMethod: () => log('ctx: setReloadMapMethod not set'),
  setSearchMethod: () => log('ctx: setSearchMethod not set'),
  setNoResultsMethod: () => log('ctx: showNoResults not set'),
  setTempStoreId: () => log('ctx: setTempStoreId not set'),
  setToggleOpenMethod: () => log('ctx: setToggleOpenMethod not set'),
  setAllStores: () => log('ctx: setAllStores not set'),
  setGoogleLoaded: () => log('ctx: setGoogleLoaded not set'),
  setSearching: () => log('ctx: setSearching not set'),
  setStockOnly: () => log('ctx: setStockOnly not set'),
});
